import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtUser, MtTask } from "server/models"
import { StateType, deepCopy } from "client/utils"
import {
    StoreType,
    UserFilters,
    TaskList,

    SortUsers,
    DelegateTask,
    LoadTaskById,

    setTaskList,
    setTaskDelegateUserIds,
    setTaskDelegateSort,
    setTaskDelegateFilters,
    setTaskDelegateSelected,
    closeModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    SpinnerIcon,
} from "client/components"

import UserSearch from "client/pages/search/userSearch"
import Columns from "./columns"

let isMounted: boolean

interface DelegateUsersProps {
    title: string
    task: MtTask
}

const DelegateUsers = ({
    title,
    task,
}: DelegateUsersProps) => {
    const taskList = useSelector((state: StoreType) => state.task.taskList)
    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const accountUserList = useSelector((state: StoreType) => state.accountUser.accountUserList)
    const projectUserList = useSelector((state: StoreType) => state.projectUser.projectUserList)

    const userIds = useSelector((state: StoreType) => state.task.delegateUsers.userIds)
    const sortColumn = useSelector((state: StoreType) => state.task.delegateUsers.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.task.delegateUsers.sortOrder)
    const filters = useSelector((state: StoreType) => state.task.delegateUsers.filters)
    const selected = useSelector((state: StoreType) => state.task.delegateUsers.selected)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedUserIds = SortUsers(Object.values(userList), sortColumn, sortOrder, filters)
        const availableUserIds = project.id
            ? (projectUserList && projectUserList[project.id]) || []
            : (accountUserList && accountUserList[userData.accountId]) || []

        const sortedDelegateUsers = sortedUserIds.filter((userId) => (
            availableUserIds.includes(userId) && task.responsible !== userId
        ))
        dispatch(setTaskDelegateUserIds(sortedDelegateUsers))
        dispatch(setTaskDelegateSelected([]))
    }, [accountUserList, projectUserList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtUser, order) => {
        dispatch(setTaskDelegateSort(column, order))
    }

    const onFilter = (newFilters: UserFilters) => {
        dispatch(setTaskDelegateFilters(newFilters))
        dispatch(setTaskDelegateSelected([]))
    }

    const delegateTask = () => {
        setSaveState(PENDING)
        DelegateTask(task.id, selected[0]).then(() => {
            LoadTaskById(task.id, userData.accountId).then((res) => {
                const taskListCopy: TaskList = taskList ? deepCopy(taskList) : {}
                taskListCopy[task.id] = res
                dispatch(setTaskList(taskListCopy))

                if (isMounted) {
                    setSaveState(IDLE)
                    dispatch(closeModal())
                }
            })
        })
    }

    const columns = Columns(task)

    return (
        <Container>
            <PageHeader>
                <PageTitle>{title}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <UserSearch
                        id="taskDelegateUsers"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={userList}
                    dataIds={userIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                />
                <PageForm>
                    <Button
                        variant="success"
                        disabled={selected.length === 0}
                        onClick={delegateTask}
                    >
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default DelegateUsers
